import React from "react";
import { useSelector, useDispatch } from "react-redux";

import "components/pages/transmissions/modal/patient/PatientModal.css";
import CustomTabs from "components/common/tabs/CustomTabs";
import AccountDocumentLink from "components/common/accountDocument/AccountDocumentLink";
import { ACCOUNT_DOCUMENT_TYPES } from "static/account_document";

import usePatientProfileTabs from "./usePatientProfileTabs";
import { changeProfileTab } from "app/store/transmission/slice/transmissionSlice";
import { Grid, Paper } from "@mui/material";

const PatientProfileTabs = () => {
  const { profileTab, profile } = useSelector((state) => state.transmission);
  const dispatch = useDispatch();

  const [tabs] = usePatientProfileTabs();

  return (
    <Paper square elevation={0}>
      <Grid container style={{ padding: "0 24px" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #E0E0E0",
            backgroundColor: "#ffffff",
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <CustomTabs
              tabs={tabs}
              selectedTab={profileTab}
              onChange={(newTab) => dispatch(changeProfileTab(newTab))}
              showContent={false}
              style={{
                container: {
                  backgroundColor: "#ffffff",
                },
                tab: {
                  backgroundColor: "#ffffff",
                  border: "none",
                },
              }}
              extraProps={{
                indicator: {
                  style: {
                    border: "none",
                  },
                },
              }}
            />
          </div>
          <AccountDocumentLink
            accountName={profile?.account}
            documentType={ACCOUNT_DOCUMENT_TYPES.CLINIC_PROTOCOL}
            label="Clinic Protocol"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PatientProfileTabs;
